import axios from "axios";
import { clearLoginData } from "../../../helpers/helpers";

export function UnsubscribeRedirect(hostName,props) {
  const userId = localStorage.userId;
  if(hostName === "ethio.playit.mobi") {
    //ethioUnsubscribe(userId,props);
    window.location.href = 'sms:6040;?&body=Stop';
    
  }
  if(hostName === "omantel.playit.mobi") {
    omantelUnsubscribe(userId,props);
  }
  if(hostName === "umniah.playit.mobi") {
    umniahUnsubscribe(userId,props);
  }
  if(hostName === "jawwal.playit.mobi") {
    jawwalUnsubscribe(userId,props);
  }

  if(hostName === "mtnng.playit.mobi") {
    nigeriaUnsubscribe(userId,props);
  }

  if(hostName === "jawwal.gamezroid.com") {
    jawwalGamezroidUnsubscribe(userId,props);
  }

  if(hostName === "ooredoops.playit.mobi") {
    ooredoopsUnsubscribe(userId,props);
  }

  if(hostName === "zainiq.gamezroid.com") {
    zainiqUnsubscribe(userId,props);
  }
  // if(hostName === "dzo.playit.mobi") {
  //   dzoUnsubscribe(userId,props);
  // }

  //dzoUnsubscribe(userId,props);
}

async function ethioUnsubscribe(id,props) {
  try {
    const params = {
      objectId: id
    };
    const headers = {
      EthAuthorization: "Basic RXRoaW9TREFwaTpLdGFmV0x3OFdFRDhWR3d3eXk="
    };
    // const res = await axios.get(url, {params});
   // const res = await axios.post(url, params, { headers });

   const url = "http://www.api.playit.mobi/api/v2/Ethio/unSubscribe?objectId="+id;
   const config = {
      method: 'get',
      url: url,
      headers: { 'EthAuthorization': 'Basic RXRoaW9TREFwaTpLdGFmV0x3OFdFRDhWR3d3eXk=' }
    }
    const res = await axios(config)

    if (res.data && res.data !== "") {
      clearLoginData();
      return props.history.push("/login");
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}

async function umniahUnsubscribe(id,props) {
  try {
    const params = {
      objectId: id
    };
    // const res = await axios.get(url, {params});
   // const res = await axios.post(url, params, { headers });

   const url = "http://www.api.playit.mobi/api/v2/umniah/unSubscribe?objectId="+id;
   const config = {
      method: 'get',
      url: url
    }
    const res = await axios(config)

    if (res.data && res.data !== "" && res.data.status) {
      clearLoginData();
      return props.history.push("/login");
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}

async function omantelUnsubscribe(id,props) {
  try {
    const params = {
      objectId: id
    };
    // const res = await axios.get(url, {params});
   // const res = await axios.post(url, params, { headers });

   const url = "http://www.api.playit.mobi/api/v2/omantel/optoutRequest?objectId="+id;
   const config = {
      method: 'get',
      url: url
    }
    const res = await axios(config)

    if (res.data && res.data !== "" && res.data.status) {
      clearLoginData();
      return props.history.push("/login");
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}

async function zainiqUnsubscribe(id,props) {
  try {
    const params = {
      objectId: id
    };
    // const res = await axios.get(url, {params});
   // const res = await axios.post(url, params, { headers });

   const url = "http://www.api.playit.mobi/api/v2/omantel/optoutRequest?objectId="+id;
   const config = {
      method: 'get',
      url: url
    }
    const res = await axios(config)

    if (res.data && res.data !== "" && res.data.status) {
      clearLoginData();
      return props.history.push("/login");
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}

async function jawwalUnsubscribe(id,props) {
  try {
    const params = {
      objectId: id
    };
    // const res = await axios.get(url, {params});
   // const res = await axios.post(url, params, { headers });
   const url = "http://api.playit.mobi/api/v2/zainiq/gamezroid/unsubscribeUser?objectId="+id;
   const config = {
      method: 'get',
      url: url
    }
    const res = await axios(config)

    if (res.data && res.data !== "" && res.data.status == "Success") {
      clearLoginData();
      return props.history.push("/login");
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}

async function nigeriaUnsubscribe(id,props) {
  try {
    const params = {
      objectId: id
    };
    // const res = await axios.get(url, {params});
   // const res = await axios.post(url, params, { headers });

  // http://api.playit.mobi//api/v2/nigeria/unsubscribe

   const url = "http://www.api.playit.mobi/api/v2/nigeria/unsubscribe?objectId="+id;
   const config = {
      method: 'get',
      url: url
    }
    const res = await axios(config);
    console.log("uns" , res)

    if (res.data && res.data !== "" && res.data.status == true) {
      clearLoginData();
      return props.history.push("/login");
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}

async function jawwalGamezroidUnsubscribe(id,props) {
  try {
    const params = {
      objectId: id
    };
    // const res = await axios.get(url, {params});
   // const res = await axios.post(url, params, { headers });
  // http://api.playit.mobi/api/v2/jawwal/gamezroid/unSubscribe?objectId=I2jAdJETno

   const url = "http://www.api.playit.mobi/api/v2/jawwal/gamezroid/unSubscribe?objectId="+id;
   const config = {
      method: 'get',
      url: url
    }
    const res = await axios(config)

    if (res.data && res.data !== "" && res.data.status == "Success") {
      clearLoginData();
      return props.history.push("/login");
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}


async function ooredoopsUnsubscribe(id,props) {
  try {
    const params = {
      objectId: id
    };
    // const res = await axios.get(url, {params});
   // const res = await axios.post(url, params, { headers });
   //http://api.playit.mobi/api/v2/imi/ooredoo/unSubscribe?objectId=dd
   const url = "http://api.playit.mobi/api/v2/imi/ooredoo/unSubscribe?objectId="+id;
   const config = {
      method: 'get',
      url: url
    }
    const res = await axios(config)

    if (res.data && res.data !== "" && res.data.status == true) {
      clearLoginData();
      return props.history.push("/login");
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}

async function dzoUnsubscribe(id,props) {
  try {
    const params = {
      objectId: id
    };
 
   const url = "http://www.api.playit.mobi/api/v1/mondia/deleteSubDetails?uuid="+id;
   const config = {
      method: 'get',
      url: url
    }
    const res = await axios(config);
    console.log(res)

    if (res.data && res.data !== "" && res.data.status) {
      clearLoginData();
      return props.history.push("/login");
    }
    return false;
  } catch (err) {
    console.log(err);
    return false;
  }
}




